module.exports = __webpack_public_path__ + "img/ic_bed_heat_bg.17ac48ee.png";